export class StateModel {
  name: string;
  abbreviation: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/state.model.ts